import { useProductConfig } from "context/ProductContext";
import { useIsMobile } from "hooks";
import { formatRegisteredSymbol } from "utils/textFormatting";

const TermBanner = () => {
    const config = useProductConfig();
    const isMobile = useIsMobile();
    return (
        <div className="w-full flex tablet:justify-start justify-center tablet:relative">
            <div className="card p-4 relative w-full max-w-sm tablet:max-w-none tablet:w-fit h-auto tablet:h-auto rounded-tl-2xl rounded-tr-2xl rounded-bl-none rounded-br-none tablet:rounded-tr-2xl tablet:rounded-br-2xl tablet:rounded-tl-none tablet:rounded-bl-none large:rounded-tl-2xl large:rounded-bl-2xl tablet:py-5 tablet:pr-5 tablet:pl-6 large:pl-6 bg-accent bg-opacity-95 flex flex-col justify-center items-center tablet:items-start gap-1 tablet:before:content-[''] tablet:before:absolute tablet:before:inset-y-0 tablet:before:right-full tablet:before:left-[-100vw] tablet:before:bg-accent tablet:before:bg-opacity-95 large:before:content-none">
                <h1 className="text-white text-md tablet:text-lg font-bold m-0 p-0 leading-7 tracking-[0%] w-full text-center tablet:text-left">
                    {formatRegisteredSymbol(config.termBanner.title1)}
                    {config.termBanner.title2 && !isMobile && (
                        <>
                            <br />
                            {config.termBanner.title2}
                        </>
                    )}
                </h1>
                <div className="text-white text-3xl tablet:text-4xl m-0 p-0 tracking-[0%] tablet:leading-[100%] leading-[40px] text-center tablet:text-left w-full tablet:w-max tablet:max-w-[370px]">
                    {isMobile ? (
                        <>
                            {config.termBanner.subtitleMobile1}
                            {formatRegisteredSymbol(config.termBanner.subtitleMobile2)}
                            {config.termBanner.subtitleMobile3} <br />
                            {config.termBanner.subtitleMobile4}
                        </>
                    ) : (
                        <>
                            {config.termBanner.subtitle1} <br />
                            {config.termBanner.subtitle2}
                            {config.termBanner.subtitle3} <br />
                            {config.termBanner.subtitle4}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TermBanner;
